export default __webpack_public_path__ + "static/media/6.5804892f.jpg";